import { DashedArrow } from "../../components/DashedArrow";
import { VendorMark } from "../../components/VendorMark";

/**
 * The chrome of the OAuth return pages (XeroOrg.html), which the design draws WITHOUT the app shell: a
 * centred 560 px column, top-aligned, with the source → destination vendor marks (decorative) above the
 * eyebrow and the h1. `/oauth/xero/return` and `/oauth/hmrc/return` share it.
 */
export function ReturnPage({
  sourceSystem,
  eyebrow,
  title,
  children,
}: {
  /** The vendor the operator is coming back FROM (the destination side is always LuciBook here). */
  sourceSystem: string;
  eyebrow?: string;
  title: string;
  children: React.ReactNode;
}): JSX.Element {
  return (
    <main className="returnpage">
      <div className="returnpage__col">
        <div className="returnpage__marks" aria-hidden="true">
          <VendorMark system={sourceSystem} size={40} />
          <DashedArrow size="narrow" />
          <VendorMark system="lucibook" size={40} />
        </div>
        <div className="page__title-group">
          {eyebrow === undefined ? null : <p className="eyebrow">{eyebrow}</p>}
          <h1>{title}</h1>
        </div>
        {children}
      </div>
    </main>
  );
}
